import { residents } from '../store.js';
  import { ServiceState, API_BASE_URL } from '../constants';
  import { batchUpsertResidents, batchDeleteResidents } from '../firebase/db.js';
  import { get, writable } from 'svelte/store';
  import { uuid } from 'uuidv4';
  import { AppFactory } from '../util.js';

export const UpdaterService = () => {
  const progress = writable({
    status: ServiceState.IDLE,
    records: 0,
    record: 0,
  });

  const { subscribe, set, update } = progress;

  const sync = async (updates) => {
    let deleteBatch = [];
    let updateBatch = [];
    
    try {

      // remove accounts that don't exist in UBMax
      const currentUBMaxAccountNumbers = updates.map(resident => resident.ubmax_acc);
      // only remove accounts that start with number and are not included in the update
      const residentsToDelete = get(residents)
        .filter(resident => !currentUBMaxAccountNumbers.includes(resident.ubmax_acc) 
          && resident.ubmax_acc.match(/^\d/));
      progress.update(current => Object.assign({status: ServiceState.PROCESSING_DELETES, records: residentsToDelete.length, record: 0}));
      residentsToDelete.forEach(async (resident) => {
        deleteBatch.push(resident);
        progress.update(current => Object.assign(current, {record: current.record + 1}));
        if (deleteBatch.length >= 250) {
          processDelete(deleteBatch);
          deleteBatch = [];
        }
      });
      if (deleteBatch.length) await processDelete(deleteBatch);

      // add new accounts and update existing
      progress.update(current => Object.assign({status: ServiceState.PROCESSING_UPDATES, records: updates.length, record: 0}));
      updates.forEach(async (ubmax_user) => {
        updateBatch.push(updateResident(findResident(ubmax_user.ubmax_acc), ubmax_user));
        progress.update(current => Object.assign(current, {record: current.record + 1}))
        if (updateBatch.length >= 250) {
          processUpdate(updateBatch)
          updateBatch = [];
        }
      });
      if (updateBatch.length) await processUpdate(updateBatch);
      progress.update(current => Object.assign(current, {status: ServiceState.UPDATE_COMPLETE}));
    } catch(err) {
      progress.update(current => Object.assign(current, {status: ServiceState.ERROR}));
      console.log(err);
      throw err;
    }
  }

  return {
    subscribe, set, update,
    sync
  }
}
  
const updateLocalResidents = (updateBatch) => {
  const residentsCopy = Object.assign(get(residents));
  updateBatch.forEach(update => {
    const residentIndex = residentsCopy.findIndex(resident => resident.resident_id === update.resident_id);
    residentIndex !== -1 ? 
      residentsCopy[residentIndex] = update :
      residentsCopy.push(update);
  });
  residents.set(residentsCopy);
}

const deleteLocalResidents = (deleteBatch) => {
  let residentsCopy = Object.assign(get(residents));
  const idsToRemove = deleteBatch.map(resident => resident.resident_id);
  residentsCopy = residentsCopy
    .filter(resident => !idsToRemove.includes(resident.resident_id))
  residents.set(residentsCopy);
}

const findResident = (accountNumber) => {
  return get(residents).find(resident => resident.ubmax_acc === accountNumber);
}

const updateResident = (resident, ubmax_user) => {
  return resident ? 
    Object.assign(resident, ubmax_user) : 
    Object.assign(AppFactory.getNewResident(), ubmax_user, {resident_id: uuid()});
}

const processUpdate = async (updateBatch) => {
  batchUpsertResidents(updateBatch);
  updateLocalResidents(updateBatch);
}

const processDelete = async (deleteBatch) => {
  batchDeleteResidents(deleteBatch);
  deleteLocalResidents(deleteBatch);
}
